import { PwcCKEditors } from '@pwc/pwc-deals-rich-text-editor';
import {
  toggleResolveCommentThreadThunk,
  setResolvedThreadId,
  setActiveThreadId,
} from '../../../features/comments/commentsSlice';
import { COMMENT_VIEWING_STATUS } from '../../../features/comments/constants';

const { ClassicEditor } = PwcCKEditors;
const { CommentThreadView, ButtonView } = ClassicEditor;

export function getModules(thread, user, instantiator) {
  if (thread.resolved) {
    return [
      instantiator.createResolveButtonView(thread),
      instantiator.createResolveTextView(),
    ];
  }

  return [instantiator.createResolveButtonView(thread)];
}

export default (
  dispatch,
  commentThreads,
  isEntitySharedWithClient,
  currentUser,
  projectUsers,
  currentEntityVersion,
  isProjectDisabled,
  isFakeClient
) =>
  class CustomCommentThreadView extends CommentThreadView {
    constructor(...args) {
      super(...args);

      // arg[0] (locale) = { uiLanguage, contentLanguage, contentLanguageDirection, uiLanguageDirection, t }
      // arg[1] (comment thread) = { channelId, id, comments, context, id, isReadOnly }
      // arg[2] (user) = { avatar, color, id, name }
      // arg[3] (config) = { CommentView, editorConfig, formatDateTime, maxCommentCharsWhenCollapsed, maxCommentsWhenCollapsed, maxThreadTotalWeight }
      const commentThread = args[1];
      const foundThread = commentThreads.find(
        (thread) => thread.id === commentThread.id
      );

      if (foundThread && foundThread.resolved) {
        commentThread.isReadOnly = true;
      }

      // This template definition is partially based on the default comment thread view.
      this.setTemplate({
        tag: 'div',

        attributes: {
          class: [
            'ck-thread',
            foundThread && foundThread.resolved
              ? `ck-thread--${COMMENT_VIEWING_STATUS.RESOLVED}`
              : `ck-thread--${COMMENT_VIEWING_STATUS.UNRESOLVED}`,
            this.bindTemplate.if('isActive', 'ck-thread--active'),
          ],
          // Needed for managing focus after adding a new comment.
          tabindex: 0,
          'data-thread-id': foundThread ? foundThread.id : '',
        },

        children: [
          { tag: 'div', attributes: { class: 'ck-thread-active-bar' } },
          // Adding the top bar element that will hold the dropdown.
          {
            tag: 'div',
            attributes: {
              class: 'ck-thread-top-bar',
            },
            children: foundThread && getModules(foundThread, currentUser, this),
          },
          // The rest of the view is as in the default view.
          {
            tag: 'div',
            attributes: {
              class: 'ck-thread__container',
            },
            children: [this.commentsListView, this.commentThreadInputView],
          },
        ],
      });
    }

    // eslint-disable-next-line class-methods-use-this
    createResolveTextView() {
      return {
        tag: 'span',
        children: ['Resolved'],
        attributes: { class: 'ck-resolve-text' },
      };
    }

    createResolveButtonView(commentThread) {
      const buttonView = new ButtonView(this.locale);

      const { t } = this.locale;

      const buttonLabel = commentThread.resolved
        ? 'Re-open'
        : 'Mark as resolved';

      buttonView.set({
        label: buttonLabel,
        isToggleable: !isProjectDisabled,
        tooltip: t(buttonLabel),
        withText: true,
        isEnabled: !isProjectDisabled && !isFakeClient,
        tabindex: 0,
      });

      buttonView.extendTemplate({
        attributes: {
          class: `ck-resolve-button ${
            isFakeClient ? 'disabled-resolved-comment-btn' : ''
          }`,
        },
      });

      // eslint-disable-next-line no-underscore-dangle
      const comment = commentThread.comments[0];

      buttonView.on('execute', () => {
        dispatch(
          toggleResolveCommentThreadThunk(
            {
              ...comment,
              resolved: !commentThread.resolved,
            },
            currentEntityVersion
          )
        );
        dispatch(setResolvedThreadId(commentThread.id));
        dispatch(setActiveThreadId(commentThread.id));
      });

      return buttonView;
    }
  };
